/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect, useMemo, act } from "react";
import {
  Collapse,
  Table,
  message,
  Modal,
  Select,
  Input,
  Popconfirm,
  Form,
  Button,
  Row,
  Col,
  Divider,
  Space,
  DatePicker,
  Spin,
  AutoComplete,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import API from "../../../api";
import urls from "../../../api/urls";
import "./style.scss";
const { GET_ALL_RATE_SLABS, CREATE_RATE_SLAB } = urls;
import { spaceBeforeCapital, checkNumbervalue } from "../../../utils";
import SlabSelect from "../../../views/LeadGenerationCP/NewRateCard/SlabSelect";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";

const RateCharges = ({
  rateCharge,
  quotationRateCharge,
  calculationBasisList,
  defaultRateCharge,
  actionEdit,
  userId,
}) => {
  const { Panel } = Collapse;
  const [rateCharges, setRateCharges] = useState([]);
  //const [calculationBasisList, setCalculationBasisList] = useState([]);
  const [rateSlabList, setRateSlabList] = useState([]);
  const [openSlabModal, setOpenSlabModal] = useState(false);
  const [currentSlabDetails, setCurrentSlabDetails] = useState({});

  const [popConVisible, setPopConVisible] = useState(false);
  const [openCreateSlab, setOpenCreateSlab] = useState(false);
  const [chargeHead, setChargeHead] = useState([]);
  const [slabId, setCurrentSlabId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [unitList, setUnitList] = useState([]);

  //const actionEdit = true;
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  useEffect(() => {
    getAllCharge();
  }, [quotationRateCharge, defaultRateCharge]);

  const getAllCharge = async () => {
    const data = defaultRateCharge?.map(({ _id, head, calculationBasis }) => ({
      _id,
      head,
      key: _id,
      calculationBasis,
      global: true,
    }));

    setChargeHead(
      data?.map(({ head, _id }) => ({
        label: head,
        value: head,
        key: _id,
      }))
    );
    const transformCharge = (current, past) => ({
      ...current,
      _id: Math.random(),
      key: current?.head,
      chargeType: current?.rateType,
      chargeTypeOld: past?.rateType,
      pricingType: current?.pricingType,
      pricingTypeOld: past?.pricingType,
      appliesOn: current?.appliesOn,
      appliesOnOld: past?.appliesOn,
      rate: current?.rate,
      rateOld: past?.rate,
      percentage: current?.percentage,
      percentageOld: past?.percentage,
      slabId: current?.slabId || current?.name,
      slabIdOld: past?.slabId || past?.name,
      name: current?.name,
      nameOld: past?.name,
      // activeType: current?.rate
      //   ? "rate"
      //   : current?.percentage
      //   ? "percentage"
      //   : current?.slabId || current?.name
      //   ? "slabId"
      //   : "rate",
      activeType:
        current?.rate != null
          ? "rate"
          : current?.percentage != null
          ? "percentage"
          : current?.slabId || current?.name
          ? "slabId"
          : "rate",

      rateSlab: null,
      calculationBasis: current?.calculationBasis,
      head: current?.chargesHead,
    });

    setRateCharges(
      quotationRateCharge?.current?.map((item, i) =>
        transformCharge(item, quotationRateCharge?.past?.[i] || null)
      )
    );
  };

  const disabledDate = (current) => {
    return current < moment().startOf("day");
  };

  useEffect(() => {
    // Set one default item
    initiateFormSlab();
  }, [form1]);

  const initiateFormSlab = () => {
    form1.setFieldsValue({
      slab: [{ minValue: "", maxValue: "", rateType: null, value: "" }],
    });
  };

  const dateFormat = "DD-MM-YYYY";

  const getFinancialEndDate = () => {
    const currentYear = moment().year();
    const financialEndYear =
      moment().month() >= 3 ? currentYear + 1 : currentYear; // Fiscal year ending March 31st
    return moment(`${financialEndYear}-03-31`, "DD-MM-YYYY");
  };
  const chargeTypeList = useMemo(
    () => [
      { label: "Value", value: "VALUE" },
      { label: "Percentage", value: "PERCENTAGE" },
    ],
    []
  );

  const pricingTypeList = useMemo(
    () => [
      { label: "Fixed", value: "FIXED" },
      { label: "Slab", value: "SLAB" },
    ],
    []
  );

  const appliesOnList = useMemo(
    () => [
      { label: "Shipment", value: "SHIPMENT" },
      { label: "Invoice", value: "INVOICE" },
    ],
    []
  );

  const defaultUnitList = [
    { label: "Grams", value: "GRAMS" },
    { label: "Inr", value: "INR" },
  ];

  useEffect(() => {
    setUnitList(defaultUnitList);
  }, []);

  useEffect(() => {
    if (actionEdit) {
      rateCharge(rateCharges);
    }
  }, [rateCharges, actionEdit]);

  const changeRateCharge = (value, type, record) => {
    setRateCharges((prevCharges) =>
      prevCharges.map((item) => {
        if (item._id !== record._id) return item; // Skip if not matching

        const updatedItem = { ...item, [type]: value };

        if (type === "chargeType") {
          updatedItem.activeType =
            value === "VALUE"
              ? record?.pricingType === "SLAB"
                ? "slabId"
                : "rate"
              : record?.pricingType === "SLAB"
              ? "slabId"
              : "percentage";

          if (updatedItem.activeType === "rate") {
            updatedItem.percentage = null;
          } else if (updatedItem.activeType === "percentage") {
            updatedItem.rate = null;
          }
        } else if (type === "pricingType") {
          updatedItem.activeType =
            value === "SLAB"
              ? "slabId"
              : record?.chargeType === "VALUE"
              ? "rate"
              : "percentage";
        }

        return updatedItem;
      })
    );
  };

  const changeRateSlab = (val, record) => {
    const { activeType, _id } = record;
    const propertyMap = {
      slabId: "slabId",
      rate: "rate",
      percentage: "percentage",
    };

    setRateCharges((prevCharges) =>
      prevCharges.map((item) =>
        item._id == _id ? { ...item, [propertyMap[activeType]]: val } : item
      )
    );
  };

  const createSlab = async (slabId, options, head) => {
    if (!slabId) {
      setOpenCreateSlab(true);
    } else {
      let data = [];
      if (!actionEdit) {
        data = options?.find((e) => e._id == slabId);
      } else {
        data = options?.find((e) => e.name == slabId);
      }
      setCurrentSlabId(slabId);
      const response = await API.Api(`${GET_ALL_RATE_SLABS}/${slabId}`).get();
      if (response?.status) {
        let res = response?.response?.data;

        let slabs = res?.slab || [];
        const additionalVal = slabs?.find((item) => item?.volume);
        const additionalValIndex = slabs.findIndex((item) => item?.volume);

        if (additionalValIndex !== -1) {
          slabs.splice(additionalValIndex, 1); // remove the item with `volume`
        }

        setCurrentSlabDetails(res);
        setOpenCreateSlab(true);
        form1.setFieldsValue({
          name: res?.name,
          chargesHead: res?.chargesHead,
          fromDate: res?.fromDate,
          toDate: res?.toDate,
          unit: res?.unit,
          slab: slabs,
          volume: additionalVal?.volume,
          rateType: additionalVal?.rateType,
          value: additionalVal?.value,
          // userId: userId,
        });
      } else {
        message.error(
          response?.response?.data?.message || "Can't fetch slab details."
        );
      }
    }
  };

  const addMoreCharge = async (val) => {
    if (
      rateCharges?.some(
        (item) =>
          item?.head?.trim()?.toUpperCase() === val?.head?.trim()?.toUpperCase()
      )
    ) {
      message.error("Charge head already exists");
      return;
    }
    setRateCharges((prevCharges) => [
      ...prevCharges,
      {
        _id: Math.random(),
        head: val?.head,
        calculationBasis: val?.calculationBasis,
        chargeType: null,
        pricingType: null,
        appliesOn: null,
        rate: null,
        percentage: null,
        slabId: null,
        activeType: "rate",
        global: false,
      },
    ]);
    setPopConVisible(false);
    form.resetFields();
  };

  const submitCreateSlab = async (val) => {
    let slabs = val?.slab;
    slabs = slabs.map((item) => ({
      ...item,
      minValue: parseFloat(item?.minValue),
      //volume: parseFloat(item?.volume),
      value: parseFloat(item?.value),
      maxValue: parseFloat(item?.maxValue),
    }));
    if (val?.volume) {
      slabs.push({
        minValue: parseFloat(slabs[slabs.length - 1]?.maxValue),
        volume: parseFloat(val?.volume),
        rateType: val?.rateType,
        value: parseFloat(val?.value),
      });
    }

    let payload = {
      chargesHead: val?.chargesHead,
      unit: val?.unit,
      slab: slabs,
      toDate: val?.endDate?._i || undefined,
      fromDate: moment(val?.startDate?._i).format("DD-MM-YYYY") || undefined,
      //stateCode: stateCode,
      userId: userId,
    };

    let res = await API.Api(CREATE_RATE_SLAB).post(payload);

    if (res?.status) {
      //initialize();
      if (!slabId) {
        setTimeout(() => {
          const updatedCharges = rateCharges?.map((item) =>
            item?.head == data?.chargesHead
              ? {
                  ...item,
                  slabId: data?.name,
                  activeType: "slabId",
                  _id: data?.chargesHead,
                }
              : item
          );
          setRateCharges([...updatedCharges]);
        }, 100);
      }
      resetSlabModal();
      const data = res?.response?.data;
      if (data && slabId) {
        const updatedCharges = rateCharges?.map((item) =>
          item?.head == data?.chargesHead
            ? { ...item, slabId: data?.name, activeType: "slabId" }
            : item
        );
        //changeRateCharge(data._id, "slabId", updatedCharges);
        setRateCharges([...updatedCharges]);
      }
      setOpenCreateSlab(false);
    } else {
      message.error(res?.response?.data?.message || "Internal server error.");
    }
  };

  const resetSlabModal = () => {
    setOpenCreateSlab(false), form1.resetFields(), setCurrentSlabDetails(null);
    setCurrentSlabId(null);
    initiateFormSlab();
  };

  const deleteRateCharge = (record) => {
    if (record.global) {
      message.error("Cannot delete global charge head");
      return;
    }

    setRateCharges((prevCharges) =>
      prevCharges.filter((charge) => charge._id !== record._id)
    );
  };

  const columns = useMemo(
    () => [
      {
        title: "Charge Head",
        dataIndex: "head",
        render: (text) => text,
      },
      {
        title: "Pricing Type",
        dataIndex: "pricingType",
        render: (text, record) => (
          <>
            {actionEdit ? (
              <Select
                options={pricingTypeList}
                className="rate-select"
                placeholder="Select"
                value={text}
                onChange={(value) => {
                  changeRateCharge(value, "pricingType", record);
                }}
              />
            ) : record?.pricingTypeOld && record?.pricingTypeOld !== text ? (
              <span className="high-light">
                <span>{text}</span>
                <span className="ml-05 past-val">{record?.pricingTypeOld}</span>
              </span>
            ) : (
              <span>{text}</span>
            )}
          </>
        ),
      },
      {
        title: "Charge Type",
        dataIndex: "chargeType",
        render: (text, record) => (
          <>
            {actionEdit ? (
              record?.pricingType !== "SLAB" ? (
                <Select
                  options={chargeTypeList}
                  className="rate-select"
                  placeholder="Select"
                  value={text}
                  onChange={(value) => {
                    changeRateCharge(value, "chargeType", record);
                  }}
                  style={{ width: "120px" }}
                />
              ) : (
                "N/A"
              )
            ) : record?.chargeTypeOld && record?.chargeTypeOld !== text ? (
              <span className="high-light">
                <span>{text}</span>
                <span className="ml-05 past-val">{record?.chargeTypeOld}</span>
              </span>
            ) : (
              <span>{text}</span>
            )}
          </>
        ),
      },
      {
        title: "Applied On",
        dataIndex: "appliesOn",
        render: (text, record) => (
          <>
            {actionEdit ? (
              <Select
                options={appliesOnList}
                className="rate-select"
                placeholder="Select"
                value={text}
                onChange={(value) => {
                  changeRateCharge(value, "appliesOn", record);
                }}
              />
            ) : record?.appliesOnOld && record?.appliesOnOld !== text ? (
              <span className="high-light">
                <span>{text}</span>
                <span className="ml-05 past-val">{record?.appliesOnOld}</span>
              </span>
            ) : (
              <span>{text}</span>
            )}
          </>
        ),
      },
      {
        title: "Calculation Basis",
        dataIndex: "calculationBasis",
        render: (text) => spaceBeforeCapital(text),
      },

      {
        title: "Rate/Item/Slab ID",
        dataIndex: "activeType",
        render: (text, record) => {
          // const hasPastValue =
          //   (record?.rateOld && record?.rateOld != record?.rate) ||
          //   (record?.percentageOld &&
          //     record?.percentageOld != record?.percentage) ||
          //   (record?.nameOld && record?.nameOld != record?.name);
          // const currentValue =
          //   record?.rate || record?.percentage || record?.name;
          // const pastValue =
          //   record?.rateOld || record?.percentageOld || record?.nameOld;

          const isDefined = (val) => val !== null && val !== undefined;

          const hasPastValue =
            (isDefined(record?.rateOld) &&
              isDefined(record?.rate) &&
              record.rateOld !== record.rate) ||
            (isDefined(record?.percentageOld) &&
              isDefined(record?.percentage) &&
              record.percentageOld !== record.percentage) ||
            (isDefined(record?.nameOld) &&
              isDefined(record?.name) &&
              record.nameOld !== record.name);

          const currentValue = isDefined(record?.rate)
            ? record.rate
            : isDefined(record?.percentage)
            ? record.percentage
            : isDefined(record?.name)
            ? record.name
            : 0;

          const pastValue = isDefined(record?.rateOld)
            ? record.rateOld
            : isDefined(record?.percentageOld)
            ? record.percentageOld
            : isDefined(record?.nameOld)
            ? record.nameOld
            : 0;

          return actionEdit ? (
            <>
              {record?.activeType === "slabId" ? (
                <div className="d-flex">
                  <SlabSelect
                    predefined={true}
                    head={record.head}
                    key={record.head}
                    value={record.slabId}
                    onChange={(val) => {
                      changeRateCharge(val, "slabId", record);
                    }}
                    createSlab={(id, options) => createSlab(id, options)}
                    setLoder={(loading) => setLoading(loading)}
                    userId={userId}
                    //setRateSlabList1={(val) => getCurrectRateCharge(val)}
                  />
                </div>
              ) : record?.activeType === "rate" ||
                record?.activeType === "percentage" ? (
                <>
                  <Input
                    style={{ width: "300px" }}
                    onChange={(e) => {
                      changeRateSlab(e.target.value, record);
                    }}
                    value={
                      isDefined(record?.rate)
                        ? record.rate
                        : isDefined(record?.percentage)
                        ? record.percentage
                        : ""
                    }
                    onKeyPress={(event) => {
                      if (checkNumbervalue(event)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </>
              ) : (
                record[text]
              )}
            </>
          ) : hasPastValue ? (
            <span className="high-light">
              {/* Current value */}
              {record?.name ? (
                <a onClick={() => viewSlab(record?.name)}>{currentValue}</a>
              ) : (
                currentValue
              )}
              {/* Past value */}
              <span className="ml-05 past-val">
                {record?.nameOld ? (
                  <a onClick={() => viewSlab(record?.nameOld)}>{pastValue}</a>
                ) : (
                  pastValue
                )}
              </span>
            </span>
          ) : record?.name ? (
            <a onClick={() => viewSlab(record?.name)}>{currentValue}</a>
          ) : (
            currentValue
          );
        },
      },
      {
        title: "Action",
        dataIndex: "action",
        render: (text, record) => (
          <Popconfirm
            title="Are you sure you want to delete this charge?"
            onConfirm={() => deleteRateCharge(record)}
            okText="Yes"
            cancelText="No"
          >
            {/* <Button type="link" disabled={record.global}>
              Delete
            </Button> */}
            <DeleteOutlined
              className={`delete-icon ${!actionEdit ? "disabled" : ""}`}
              style={{
                fontSize: "16px",
                color: record.global || !actionEdit ? "#d9d9d9" : "#ff4d4f",
                cursor:
                  record.global || !actionEdit ? "not-allowed" : "pointer",
              }}
            />
          </Popconfirm>
        ),
      },
    ],
    [
      chargeTypeList,
      appliesOnList,
      calculationBasisList,
      pricingTypeList,
      //changeRateCharge,
      rateSlabList,
      chargeHead,
      defaultRateCharge,
      actionEdit,
    ]
  );

  const slabColumns = useMemo(
    () => [
      {
        title: "Min Value",
        dataIndex: "minValue",
      },
      {
        title: "Max Value",
        dataIndex: "maxValue",
      },
      {
        title: "Rate",
        dataIndex: "value",
      },
      {
        title: "Rate Type",
        dataIndex: "rateType",
      },
    ],
    [calculationBasisList]
  );

  const viewSlab = async (slabName) => {
    setLoading(true);
    const response = await API.Api(`${GET_ALL_RATE_SLABS}/${slabName}`).get();
    if (response?.status) {
      let res = response?.response?.data;
      setCurrentSlabDetails(res);
      setOpenSlabModal(true);
      setLoading(false);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Can't fetch slab details."
      );
    }
  };

  return (
    <Spin spinning={loading}>
      <Collapse collapsible={"header"} defaultActiveKey={["1"]}>
        <Panel header="Value Added Charges" key="1">
          {/* {quotationRateCharge?.current?.length > 0 ? ( */}
          <>
            <Table
              columns={columns}
              dataSource={rateCharges}
              rowKey="_id"
              className="rate-charge-table"
              pagination={false}
            />
          </>
          {/* ) : (
            <div className="no-data-prresnt">No data available</div>
          )} */}
          {actionEdit && (
            <div className="ml-2 space-between">
              <Popconfirm
                icon={null}
                placement="top"
                visible={popConVisible}
                onCancel={() => setPopConVisible(false)}
                title={
                  <Form
                    className="global-form"
                    layout="vertical"
                    form={form}
                    scrollToFirstError={{
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }}
                    onFinish={addMoreCharge}
                  >
                    <Form.Item
                      name="head"
                      label="Charge Head"
                      rules={[
                        {
                          required: true,
                          message: "Enter charge head",
                        },
                      ]}
                    >
                      {/* <Input
                        placeholder="Enter charge head"
                        style={{ borderRadius: "5px" }}
                      /> */}
                      <AutoComplete
                        options={defaultRateCharge?.map((item) => ({
                          label: spaceBeforeCapital(item?.head),
                          value: item?.head,
                        }))}
                        placeholder="Select charge head"
                        filterOption={(inputValue, option) =>
                          option.value
                            .toUpperCase()
                            .indexOf(inputValue.toUpperCase()) !== -1
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      name="calculationBasis"
                      label="Select Calculation Basis"
                      rules={[
                        {
                          required: true,
                          message: "Select calculation basis",
                        },
                      ]}
                    >
                      <Select
                        options={calculationBasisList}
                        placeholder="Select"
                      />
                    </Form.Item>
                  </Form>
                }
                onConfirm={() => {
                  form.submit();
                }}
                okText="CREATE"
                cancelText="CANCEL"
              >
                <Button
                  className="save-btn mt-05"
                  onClick={() => setPopConVisible(true)}
                >
                  Add More
                </Button>
              </Popconfirm>

              {rateCharges?.some((rates) => rates?.pricingType === "SLAB") >
                0 && (
                <Button
                  className="save-btn mt-05 mr-2"
                  onClick={() => createSlab()}
                >
                  CREATE SLAB
                </Button>
              )}
            </div>
          )}
        </Panel>
      </Collapse>
      {actionEdit ? (
        <Modal
          title={
            slabId ? `Attach Slab (${currentSlabDetails?.name})` : "Create Slab"
          }
          open={openCreateSlab}
          onCancel={() => resetSlabModal()}
          width={700}
          footer={
            <div className="d-flex flex-end" style={{ padding: "1rem 0 0 0" }}>
              <Button
                onClick={() => resetSlabModal()}
                className="cancel-btn w-13"
              >
                {"CANCEL"}
              </Button>
              <Button
                onClick={() => form1.submit()}
                className="save-btn ml-1 w-13"
              >
                {"SUBMIT"}
              </Button>
            </div>
          }
        >
          <div>
            <Form
              className="global-form"
              layout="vertical"
              form={form1}
              scrollToFirstError={{
                behavior: "smooth",
                block: "center",
                inline: "center",
              }}
              onFinish={submitCreateSlab}
            >
              <Row className="global-form-row" gutter={10}>
                <Col className="form-inputs" span={6}>
                  <Form.Item
                    name="chargesHead"
                    label="Charge Head"
                    rules={[
                      {
                        required: true,
                        message: "Select charge head",
                      },
                    ]}
                  >
                    {/* <Select
                      options={chargeHead}
                      placeholder="Select charge head"
                      disabled={slabId}
                    /> */}
                    <Select
                      options={rateCharges
                        ?.filter((item) => item?.pricingType === "SLAB")
                        ?.map((item) => ({
                          label: item?.head,
                          value: item?.head,
                          calculationBasis: item?.calculationBasis,
                        }))}
                      placeholder="Select charge head"
                      disabled={slabId}
                      onChange={(value, data) => {
                        let temp = calculationBasisList?.find(
                          (item) => item?.value === data?.calculationBasis
                        )?.unit;
                        let unit = temp?.map((item) => ({
                          label: spaceBeforeCapital(item),
                          value: item,
                        }));
                        if (unit) {
                          setUnitList(unit);
                          form1.setFieldsValue({
                            unit: unit[0]?.value,
                          });
                        } else {
                          setUnitList(defaultUnitList);
                          form1.setFieldsValue({
                            unit: defaultUnitList[0]?.value,
                          });
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col className="form-inputs" span={6}>
                  <Form.Item
                    name="unit"
                    label="Unit"
                    rules={[
                      {
                        required: true,
                        message: "Enter unit",
                      },
                    ]}
                  >
                    <Select options={unitList} placeholder="Select unit" />
                  </Form.Item>
                </Col>
                <Col className="form-inputs" span={6}>
                  <Form.Item
                    name="startDate"
                    label="Start Date"
                    initialValue={moment(new Date(), dateFormat)}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Please select start date",
                    //   },
                    // ]}
                  >
                    <DatePicker
                      disabledDate={disabledDate}
                      format={dateFormat}
                    />
                  </Form.Item>
                </Col>
                <Col className="form-inputs" span={6}>
                  <Form.Item
                    name="endDate"
                    label="End Date"
                    initialValue={getFinancialEndDate()}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Please select end date",
                    //   },
                    // ]}
                  >
                    <DatePicker
                      format={dateFormat}
                      disabledDate={(current) =>
                        current && current > getFinancialEndDate()
                      }
                    />
                  </Form.Item>
                </Col>
                <Divider>Rate Slabs</Divider>

                <div className="m-05">
                  <Form.List name="slab">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map((field, index) => (
                          <Space
                            key={`slab-item-${field.name}-${index}`}
                            align="center"
                          >
                            <Form.Item
                              noStyle
                              shouldUpdate={(prevValues, curValues) =>
                                prevValues.area !== curValues.area ||
                                prevValues.sights !== curValues.sights
                              }
                            >
                              {() => (
                                <Form.Item
                                  {...field}
                                  label="Min Value"
                                  name={[field.name, "minValue"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Missing min value",
                                    },
                                  ]}
                                  onKeyPress={(event) => {
                                    if (checkNumbervalue(event)) {
                                      event.preventDefault();
                                    }
                                  }}
                                >
                                  <Input
                                    placeholder="Min Value"
                                    style={{ width: "150px" }}
                                  />
                                </Form.Item>
                              )}
                            </Form.Item>
                            {/* {index !== fields.length - 1 && ( */}
                            <Form.Item
                              {...field}
                              label="Max Value"
                              name={[field.name, "maxValue"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Missing max value",
                                },
                              ]}
                              onKeyPress={(event) => {
                                if (checkNumbervalue(event)) {
                                  event.preventDefault();
                                }
                              }}
                            >
                              <Input
                                placeholder="Max Value"
                                style={{ width: "150px" }}
                              />
                            </Form.Item>
                            {/* )} */}

                            <Form.Item
                              {...field}
                              label="Rate Type"
                              name={[field.name, "rateType"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Missing rate type",
                                },
                              ]}
                            >
                              <Select
                                options={chargeTypeList}
                                placeholder="Select rate type"
                                style={{ width: "150px" }}
                              />
                            </Form.Item>

                            <Form.Item
                              {...field}
                              label="Value"
                              name={[field.name, "value"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Missing value",
                                },
                              ]}
                              onKeyPress={(event) => {
                                if (checkNumbervalue(event)) {
                                  event.preventDefault();
                                }
                              }}
                            >
                              <Input
                                placeholder="Value"
                                style={{ width: "150px" }}
                              />
                            </Form.Item>

                            <MinusCircleOutlined
                              onClick={() => remove(field.name)}
                            />
                          </Space>
                        ))}
                        <div className="center w-100 mt-05">
                          <Form.Item>
                            <Button
                              type="dashed"
                              onClick={() => add()}
                              block
                              className="save-btn"
                              icon={<PlusOutlined />}
                            >
                              Add New Slab
                            </Button>
                          </Form.Item>
                        </div>
                      </>
                    )}
                  </Form.List>
                </div>
                {/* <Divider>Additional Value</Divider> */}
                <Space align="center" size={"middle"} className="ml-05">
                  <Form.Item
                    label="Additional Value"
                    name={"volume"}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Missing additional value",
                    //   },
                    // ]}
                    onKeyPress={(event) => {
                      if (checkNumbervalue(event)) {
                        event.preventDefault();
                      }
                    }}
                  >
                    <Input
                      placeholder="Additional Value"
                      style={{ width: "200px" }}
                    />
                  </Form.Item>
                  {/* )} */}

                  <Form.Item
                    label="Rate Type"
                    name={"rateType"}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Missing rate type",
                    //   },
                    // ]}
                  >
                    <Select
                      options={chargeTypeList}
                      placeholder="Select rate type"
                      style={{ width: "200px" }}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Value"
                    name={"value"}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Missing value",
                    //   },
                    // ]}
                    onKeyPress={(event) => {
                      if (checkNumbervalue(event)) {
                        event.preventDefault();
                      }
                    }}
                  >
                    <Input placeholder="Value" style={{ width: "200px" }} />
                  </Form.Item>
                </Space>
              </Row>
            </Form>
          </div>
        </Modal>
      ) : (
        <Modal
          title={currentSlabDetails?.name}
          open={openSlabModal}
          onCancel={() => setOpenSlabModal(false)}
          footer={null}
        >
          <div className="space-between">
            <div>
              <p>
                <b>Charges Head:</b>
                &nbsp;&nbsp;{currentSlabDetails?.chargesHead}
              </p>
              <p>
                <b>From Date:</b> {currentSlabDetails?.fromDate?.split("T")[0]}
              </p>
            </div>
            <div>
              <p>
                <b>Unit:</b>
                &nbsp;&nbsp;{currentSlabDetails?.unit}
              </p>
              <p>
                <b>To Date:</b> {currentSlabDetails?.toDate?.split("T")[0]}
              </p>
            </div>
          </div>

          <Table
            columns={slabColumns}
            dataSource={currentSlabDetails?.slab}
            className="rate-charge-table"
            pagination={false}
          />
        </Modal>
      )}
    </Spin>
  );
};

export default RateCharges;
